<template>
	<v-autocomplete
		v-model="vModel"
		:items="sortedItems"
		@keydown.enter="lookupSearch"
		@keydown.tab="lookupSearch"
		@focus="listItems"
		v-bind="$attrs"
		v-on="computedListeners"
		:outlined="$_.get($attrs, 'outlined', true)"
		:dense="$_.get($attrs, 'dense', true)"
		:loading="showLoadingProgressBar"
	>
		<!-- Forward all named slots -->
		<template v-for="slot of Object.keys($slots)" :slot="slot">
			<slot :name="slot" />
		</template>
		<!-- Forward all scoped slots -->
		<template v-for="slot of Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
			<slot :name="slot" v-bind="scope" />
		</template>
		<template v-slot:no-data>
			<v-list-item>
				<v-list-item-title> {{ $t('$global.messages.noDataAvailable') }} </v-list-item-title>
			</v-list-item>
		</template>
	</v-autocomplete>
</template>
<script>
export default {
	name: 'LAutocomplete',
	props: {
		value: {
			required: true,
		},
		clearvalue: {
			default: undefined,
		},
		items: {
			type: Array,
			required: true,
		},
		showLoadingProgressBar: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		vModel: {
			get() {
				return this.value;
			},
			set(value) {
				if (value === null) this.$emit('input', this.clearvalue);
				else this.$emit('input', value);
			},
		},
		computedListeners() {
			// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
			const { input, ...otherListeners } = this.$listeners;
			return otherListeners;
		},
		sortedItems() {
			let itemText = null;
			if (this.$attrs['item-text']) itemText = this.$attrs['item-text'];
			else if (this.$attrs.itemText) itemText = this.$attrs.itemText;
			if (itemText && typeof itemText === 'string') itemText = (value) => this.$_.get(value, itemText);

			let customCompare = undefined;
			if (typeof a === 'string' && typeof b === 'string') customCompare = (a, b) => a.localeCompare(b);

			if (itemText)
				customCompare = (a, b) =>
					(itemText(a) + '').localeCompare(itemText(b) + '', undefined, {
						numeric: true,
						sensitivity: 'base',
					});
			const sortedItems = [...this.items].sort(customCompare);
			// console.log('sortedItems', sortedItems);
			return sortedItems;
		},
	},
	methods: {
		lookupSearch() {
			const searchValue = this.$children[0].lazySearch;
			if (this.$children[0].items.includes(searchValue)) {
				this.vModel = searchValue;
				this.$children[0].blur();
			}
		},
		listItems() {
			this.$children[0].activateMenu();
		},
	},
};
</script>
